import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_ajcvx3qqyh: FaireBrandEntity = {
  token: "b_ajcvx3qqyh",
  type: "brand",
  name: "Hustle & Heart Boutique",
  avatarUrl:
    "https://cdn.faire.com/fastly/67c67703174842401257426b10c1ec86011d5e5b1a0c17d1a2fb995ba2cb88b2.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/a169286bd4fabca68fcf87fe4ed47f52d6ce0351b00c6d9bd8e428187ecc7379.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/67c67703174842401257426b10c1ec86011d5e5b1a0c17d1a2fb995ba2cb88b2.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/a169286bd4fabca68fcf87fe4ed47f52d6ce0351b00c6d9bd8e428187ecc7379.jpeg",
  location: "Linden, TN, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 3,
  isInsider: true,
  description:
    "Our Story — Hustle & Heart Boutique\nSome businesses are built in boardrooms. Mine was built in the middle of school pickups, nap times, and the beautiful, beautiful chaos of raising four kids.\nI'm Brooklyn, the founder and heart behind Hustle & Heart Boutique — a custom apparel brand born from a small town, a big dream, and a whole lot of late nights at the craft table. If you're a retailer looking for a brand with a real story, a genuine product, and a maker who pours everything she has into every single piece — you're in the right place. If you are interested in checking out my website and applying for wholesale program please go to hustleheartboutique.shop. ",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:20.071Z",
    importedBy: "entity-db-cli",
  },
};
